import { Link } from "react-router-dom";
import AxiosClient from "../../assets/AxiosClient";
import { useEffect, useState } from "react";
import { useStateContext } from "../../Contexts/ContextProvider";

const InvitationsRow = ({ id, title, invitation_code, status, onDelete, user, expired_at }) => {
  const { SetNotification } = useStateContext();
  const handleDeleteArt = () => {
    const confirmed = window.confirm("Are you sure you want to delete this Invitation Code?");

    if (confirmed) {
      onDelete(id);
    }
  };

  function handleCopy() {
    const codeString = invitation_code; // Replace with your actual code string

    navigator.clipboard
      .writeText(codeString)
      .then(() => {
        SetNotification("Code copied to clipboard!", "info");
        // You can show a success message or perform other actions here
      })
      .catch((error) => {
        SetNotification("Failed to copy code to clipboard:", "danger");
        // You can show an error message or perform other error handling here
      });
  }

  const isExpired = new Date(expired_at) < new Date(); // Check if the expiration date is in the past

  return (
    <>
      <tr>
        <td>
          <div className=" px-2">
            <div></div>
            <div className="">
              <h6 className="mb-0 ">{title}</h6>
            </div>
          </div>
        </td>
        <td>
          <span className=" font-weight-bold">{invitation_code}</span>
        </td>
        <td className="align-middle text-center">
          <div className="d-flex align-items-center justify-content-center">
            <span className={`me-2  font-weight-bold btn ${isExpired ? 'btn-danger' : (status === "pending" ? 'btn-success' : 'btn-dark')}`}>
              {isExpired ? "Expired" : (status === "pending" ? "Active" : "Passed")}
            </span>
            <div></div>
          </div>
        </td>
        <td className="align-middle text-center">
          <div className="d-flex align-items-center justify-content-center">
            <div>
              {user !== "System Admin" ? (
                <span className="text-success h6">{user}</span>
              ) : (
                <span>not used yet</span>
              )}
            </div>
          </div>
        </td>
        <td className="align-middle">
          <br />
          <button className="btn btn-danger  m-2" onClick={handleDeleteArt}>
            Delete Code
          </button>
          <button className="btn btn-dark  m-2" onClick={handleCopy}>
            Copy Code
          </button>
        </td>
      </tr>
    </>
  );
};

export default InvitationsRow;